module.exports = __webpack_public_path__ + "static/media/hero_m@2x.9a5ab0e6.jpg";